/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef } from "react";
// @mui
import {
  Badge,
  IconButton,
  Avatar,
  Typography,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  CircularProgress,
  Button,
} from "@mui/material";

import Iconify from "../../components/Iconify";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";

import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Link } from "react-router-dom";
import { customTheme } from "../../theme";
import {
  deleteNotifications,
  markUserNotificationsAsRead,
  selectAllUserNotifications,
  selectAllUserNotificationStatus,
} from "../../core/redux/features/users/userSlice";
import { UserNotification } from "../../pages/UserNotificationsPage";

export default function UserNotificationsPopover() {
  const anchorRef = useRef(null);
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(selectAllUserNotifications);
  const notificationStatus = useAppSelector(selectAllUserNotificationStatus);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReadMessage = (id: string) => {
    dispatch(markUserNotificationsAsRead([id]));
  };
  const handleDeleteMessage = (id: string) => {
    dispatch(deleteNotifications(id));
  };

  return (
    <>
      <Button
        ref={anchorRef}
        // color={open ? "primary" : "default"}
        onClick={handleClick}
        sx={{
          //   width: 40,
          //   height: 40,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "row",
          gap: 1,
          padding: 2,
          alignItems: "center",
          justifyContent: "space-between",

          color: open ? customTheme.palette.primary : "black",
        }}
      >
        <Typography>Users</Typography>

        <Badge
          badgeContent={notifications.filter((item) => !item.isReadBy).length}
          color="error"
        >
          <Iconify icon="eva:bell-fill" width={20} height={20} />
        </Badge>
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ maxWidth: { xs: 300, md: 400, lg: 500 } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {notifications.slice(0, 5).map((i) => (
          <UserNotificationItem
            {...i}
            handleReadMessage={handleReadMessage}
            handleDeleteMessage={handleDeleteMessage}
            statusPatch={notificationStatus}
          />
        ))}
        <Link to="user-notifications">
          <MenuItem
            onClick={handleClose}
            sx={{
              textAlign: "center",
              justifyContent: "center",
              mt: 1,
              width: "100%",
            }}
          >
            View All
          </MenuItem>
        </Link>
      </Menu>
    </>
  );
}

interface UserNotificationItemProps extends Partial<UserNotification> {
  handleReadMessage: (id: string) => void;
  handleDeleteMessage: (id: string) => void;
  statusPatch: "idle" | "success" | "loading" | "fail";
}

function UserNotificationItem(props: UserNotificationItemProps) {
  return (
    <Stack
      p="10px 20px 10px 10px"
      borderBottom="1px solid #b3b3b3"
      direction="row"
      alignItems="center"
      // spacing={2}
      justifyContent="space-between"
    >
      <Tooltip title={props.body} placement="left">
        <Stack direction="row" alignItems="center">
          <Avatar sx={{ bgcolor: "background.neutral" }}>
            <img alt={props._id} src="/static/icons/ic_notification_chat.svg" />
          </Avatar>

          <Typography variant="subtitle1" width="150px">
            {props.title}
          </Typography>
        </Stack>
      </Tooltip>

      {!props.isReadBy && (
        <Tooltip title="Click to mark as read" placement="left">
          <IconButton
            onClick={() => props.handleReadMessage(String(props._id))}
            disabled={props.statusPatch === "loading" ? true : false}
          >
            {props.statusPatch === "loading" ? (
              <CircularProgress size="20px" />
            ) : (
              <DoneAllIcon fontSize="small" color="success" />
            )}
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
